<div class="container">
  <ziro-breadcrumbs>
    <ziro-breadcrumb-card-item [aboutCardId]="141"></ziro-breadcrumb-card-item>
  </ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <div class="d-flex flex-wrap column-gap-4">
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="migration-status-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="migrationStatusData"
          [label]="'tkey;migrations.number_report.dashboard.migration_status.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.migration_status.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="migrationStatusCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.number_report.dashboard.numbers.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'migrationStatus')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="usage-type-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="usageTypeData"
          [label]="'tkey;migrations.number_report.dashboard.usage_type.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.usage_type.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="usageTypeCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.number_report.dashboard.numbers.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'lineType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="device-type-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="deviceTypeData"
          [label]="'tkey;migrations.number_report.dashboard.device_type.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.device_type.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="deviceTypeCustomColors"
          [segmentTooltipKeyword]="''"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'deviceType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
    </div>
  }
</div>
